import { useMutation, useQueryClient } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { AUTO_ASSESSMENTS_API } from '../autoAssessmentsAPIClient';
import {
  IAssessmentsOnSuccessParam,
  IUpdateAssessmentRequestPayload,
} from '../types';

import { AUTO_ASSESSMENTS_FILTERS_KEY } from './useAutoAssessmentsFiltersQuery';

export const AUTO_ASSESSMENTS_SUBMIT_KEY = 'auto-assessments-submit-key';

interface IAutoAssessmentsSubmitOrRetakeMutationParam {
  onError: (err: IApiError) => void;
  onSuccess: (response: IAssessmentsOnSuccessParam) => void;
}

export interface IUpdateAssessmentRequestMutationPayload {
  payload: IUpdateAssessmentRequestPayload;
  identifier?: string;
}

/**
 * Performs a filter request and retrieves the auto assessments filter options.
 */
export const useAutoAssessmentsSubmitOrRetakeMutation = ({
  onError,
  onSuccess,
}: IAutoAssessmentsSubmitOrRetakeMutationParam) => {
  const queryClient = useQueryClient();

  const invalidateFiltersCache = () => {
    queryClient.invalidateQueries({
      queryKey: [AUTO_ASSESSMENTS_FILTERS_KEY],
    });
  };

  const {
    isPending,
    error,
    data,
    mutate: updateRequest,
  } = useMutation({
    mutationKey: [AUTO_ASSESSMENTS_SUBMIT_KEY],
    networkMode: 'always',
    mutationFn: AUTO_ASSESSMENTS_API.updateAssessmentRequest,
    onError: (err: IApiError) => {
      onError(err);
      invalidateFiltersCache();
    },
    onSuccess: (resData: IAssessmentsOnSuccessParam) => {
      onSuccess(resData);
      invalidateFiltersCache();
    },
  });

  return {
    data,
    error,
    isPending,
    updateRequest,
  };
};
